var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKuwait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.9839C31.6479 20.2506 32 18.3758 32 16.4187C32 14.4616 31.6479 12.5868 31.0048 10.8535L16 9.46217L0.995188 10.8535C0.352063 12.5868 0 14.4616 0 16.4187C0 18.3758 0.352063 20.2506 0.995188 21.9839L16 23.3752L31.0048 21.9839Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 32.419C22.8795 32.419 28.7442 28.077 31.0049 21.9842H0.995239C3.25599 28.077 9.12061 32.419 16.0001 32.419Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.418945C9.12061 0.418945 3.25599 4.76095 0.995239 10.8538H31.0049C28.7442 4.76095 22.8795 0.418945 16.0001 0.418945Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68628 5.10477C-1.56209 11.3531 -1.56209 21.4838 4.68628 27.7323C6.31722 26.1013 7.90909 24.5095 10.4348 21.9838V10.8533L4.68628 5.10477Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuwait);
export default __webpack_public_path__ + "static/media/kuwait.89dad998.svg";
export { ForwardRef as ReactComponent };